import { render } from "./AdministrationGroupView.vue?vue&type=template&id=211a3d8b&scoped=true"
import script from "./AdministrationGroupView.vue?vue&type=script&lang=js"
export * from "./AdministrationGroupView.vue?vue&type=script&lang=js"

import "./AdministrationGroupView.vue?vue&type=style&index=0&id=211a3d8b&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211a3d8b"]])

export default __exports__